import React, { useState, useEffect } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import {
  GET_MESSAGES_BY_PAGESIZE_AND_PAGE_NUMBER,
  SUBSCRIBE_TO_MESSAGE_ADDED,
  MARK_MESSAGE_AS_READ,
  MARK_MESSAGE_AS_UNREAD
} from 'graphql/service';
import { debouncedErrorMessage } from 'utils/messageUtil';

const useMessages = () => {

  const pageSize=15
  const [offset, setOffset] = useState(0)
  const [messages, setMessages] = useState([])
  const { loading, data, error, fetchMore, subscribeToMore } = useQuery(GET_MESSAGES_BY_PAGESIZE_AND_PAGE_NUMBER,
    {
      fetchPolicy: "cache-first",
      variables: {
        input: {
          pagination: {
            limit: pageSize,
            offset: offset
          }
        }
      }
    }
  )

  useEffect(() => {
    if (data?.latestIncomingMessages) {
      setMessages(data.latestIncomingMessages.items)
    }
  }, [data]);

  useEffect(() => {
    if (!error) return;

    if (!error.networkError) {
      let content = error.message;

      if (error.message.includes('Validation')) {
        content = JSON.stringify(
          error.graphQLErrors[0]?.extensions?.exception
        );
      }

      debouncedErrorMessage(content);
    }
  }, [error]);

  useEffect(() => {

    if (!subscribeToMore) return;
    if (data) {
      const unsubscribe = subscribeToMore({
        document: SUBSCRIBE_TO_MESSAGE_ADDED,
        updateQuery: (prev,{ subscriptionData }) => {
          if (!subscriptionData.data?.latestInboundMessagesUpdated) return 
          const newMessage = subscriptionData.data.latestInboundMessagesUpdated.message;
          if(!newMessage) return prev;
          if (prev.latestIncomingMessages?.items.some(message => message.messageId === newMessage.messageId)) {
            return prev;
          } else {
            setOffset(prevOffset => prevOffset + 1);
          }

          return {
            ...prev,
            latestIncomingMessages: {
              ...prev.latestIncomingMessages,
              items: [newMessage,...(prev.latestIncomingMessages.items || [])]
            },
          }
        },
        onError: (error) => {
          console.error("[SUB ERROR PAYLOAD]", error)
        }
      });

      return () => {
        unsubscribe();
      };
    }
  }, [subscribeToMore]);

  const [markMessageAsRead] = useMutation(MARK_MESSAGE_AS_READ, {
    onError: (error) => {
      if (!error.networkError) {
        let content = error.message
        if(error.message.includes('Validation')) {
            content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
        }
        debouncedErrorMessage(content)
      }
    }
  });

  const [markMessageAsUnread] = useMutation(MARK_MESSAGE_AS_UNREAD, {
    onError: (error) => {
      if (!error.networkError) {
        let content = error.message
        if(error.message.includes('Validation')) {
            content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
        }
        debouncedErrorMessage(content)
      }
    }
  });

  return {
    markMessageAsRead,
    markMessageAsUnread,
    fetchMore,
    pageSize,
    offset,
    setOffset,
    loading,
    messages,
    setMessages
  }
}

export default useMessages
